<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, Button } from '@Shelly/shelly-design-system';
	//Helpers
	import { isValidURL } from 'src/helpers/utilities';

	export let tokens: string[], selectedInputField: HTMLInputElement;

	const addToURL = (token: string): void => {
		if (selectedInputField && isValidURL(selectedInputField.value, true)) {
			if (selectedInputField.selectionStart >= 0) {
				const newText =
					selectedInputField.value.substring(0, selectedInputField.selectionStart) + token;
				selectedInputField.value =
					newText +
					selectedInputField.value.substring(
						selectedInputField.selectionEnd,
						selectedInputField.value.length,
					);
				selectedInputField.focus();
				selectedInputField.selectionStart = selectedInputField.selectionEnd = newText.length;
			} else {
				selectedInputField.value += token;
				selectedInputField.focus();
			}
			selectedInputField.dispatchEvent(new Event('input'));
		}
	};
</script>

<Text class="mt-s" styleType="body-small">
	{$format('token_replacements', {
		default: 'Available token replacements:',
	})}
</Text>
<div class="d-flex flex-wrap">
	{#each tokens as token}
		{@const tokenString = `\${${token}}`}
		<Button
			class="token-btn"
			variant="custom"
			disabled={!(selectedInputField && isValidURL(selectedInputField.value, true))}
			on:click={() => addToURL(tokenString)}
		>
			{tokenString}
		</Button>
	{/each}
</div>
